module.exports = __webpack_public_path__ + "img/ico-chev-down--orange.6de4f084.svg";